import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import './assets/tailwind.css'
import 'remixicon/fonts/remixicon.css'
import 'intl-tel-input/build/css/intlTelInput.css'
import 'lightgallery/css/lightgallery.css'
import 'lightgallery/css/lg-zoom.css'
import 'lightgallery/css/lg-thumbnail.css'
import noRightClick from './directives/noRightClick';
import './registerServiceWorker'

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

app.use(pinia)
app.use(router)
app.use(head)
app.directive('no-right-click', noRightClick);
app.mount('#app')
